<template>
  <div :class=" source.name === 'Datis' ? 'list-table-wrapper' : '' ">
    <table class="table widget-table line-height-tight" style="margin-bottom: 0">
      <thead>
      <tr>
        <th :colspan="99" class="th-filters">
          <div class="widget-filters">
            <div>
              <input
                  v-if=" source.name === 'Datis' "
                  type="text"
                  v-model="textFilterDati"
                  :placeholder="filterPlaceholder"
                  @keyup.enter="SearchDatiByName"
              />
              <input
                  v-else
                  type="text"
                  v-model="textFilter"
                  :placeholder="filterPlaceholder"
              />
            </div>
            <div
                v-if="source.name === 'Events'"
                class="toolbar-control"
                @click="handleCheck"
                style="display: flex; flex: 1 0 auto; line-height: 1;"
            >
                <span>
                  <span class="checkbox" :class="{ check: onlyAlert }">
                    <i class="fa fa-check"></i>
                  </span>
                </span>
              <span
                  style="display: flex; align-items: center; line-height: 1"
              >{{ $t("home.widgets.onlyAlert") }}
                </span>
            </div>
            <div
                v-else
                class="queryDati-wrapper"
                @click="SearchDatiByName"
            >
              <i class="fa fa-search"></i>
            </div>
          </div>
        </th>
      </tr>

      <tr>
        <th
            v-for="(head, index) in headers"
            :key="index"
            class="capitalize"
            :style="{ width: 100/headers.length + '%' }"
        >
          {{ head }}
        </th>
        <th v-if="source.name === 'Datis'" class="px-0" style="width: 40px"></th>
      </tr>
      </thead>
      <tbody v-if="isLoading">
      <tr>
        <td colspan="99" class="text-center p-4">
          <div class="spinner-border text-secondary" role="status">
            <span class="sr-only">{{ $t("global.loading") }}</span>
          </div>
        </td>
      </tr>
      </tbody>
      <tbody v-else>
      <tr
          v-for="item in filteredList"
          :class="item.className"
          @click="handleClick(item)"
      >
        <template v-if="!!item.rowType && item.rowType === 'lostCom'">
          <td>
            <router-link
                :to="{
                  name: 'DevicesShow',
                  params: { id: item.rowData.dati.id },
                }"
                tag="a"
            >
              <span class="widget-list-first-label underline m-0">{{ item.rowData.dati.name }}</span>
            </router-link>
          </td>
          <td>
            <UiButton
                v-if="isLostcomAged(item) && useDvFlagAccess('beepiz-dashboard-stop-lost-com-session-can:update')"
                @click.native.prevent="handleRemoveLostcom(item)"
                class="btn-outline-danger btn-sm d-inline-block text-truncate"
                :disabled="lostComDisableButton"
            >
              <i class="fa fa-stop-circle mr-1" aria-hidden="true"></i>
              {{ $t('global.stop') }}
            </UiButton>
          </td>
          <td>
            <strong>
              <i class="zmdi zmdi-network-off"></i>
              {{ $t('home.widgets.list.lostcom') }}
            </strong>
            <UiRelativeDate :date="item.rowData.lost_com_at.date" class=""/>
          </td>
        </template>
        <template v-if="!!item.rowType && item.rowType === 'vocal'">
          <td align="right">
            <router-link
                :to="{
                  name: 'DevicesShow',
                  params: { id: item.rowData.dati.id },
                }"
                tag="a"
            >
              <strong class="widget-list-first-label underline m-0">{{
                  $t('home.widgets.vocal.vocal_message')
                }}</strong>
            </router-link>
          </td>

          <td>
            <UiButton
                @click.native.prevent="playVocal(item)"
                class="btn-light btn-sm d-inline-block text-truncate"
            >
              <i class="fa fa-play-circle mr-1" aria-hidden="true"></i>
              {{ $t('global.lire') }}
            </UiButton>
          </td>
          <td></td>
        </template>
        <template
            v-if="!!item && !!item.cellsMarkup && item.cellsMarkup.length == headers.length &&
            !notInRowType(item.rowType)"
        >
          <template v-for="(col, keyCol) in item.cellsMarkup">
            <td
                v-if="!item.cellsLink[keyCol]"
                class="widget-list-cell"
                v-html="col"
                :key="item.key+'-'+keyCol+'no-link'"
            ></td>
            <router-link
                v-else
                :to="item.cellsLink[keyCol]"
                tag="td"
                v-html="col"
                class="widget-list-cell link"
                :key="item.key+'-'+keyCol+'link'"
            ></router-link>
          </template>
        </template>
        <td
            v-if="item.cellsMarkup.length != headers.length"
            :colspan="headers.length"
            v-html="item.cellsMarkup ? item.cellsMarkup[0] : ''"
            :key="item.key"
        ></td>
        <td v-if="source.name === 'Datis'" class="px-0" style="width: 40px">
          <button
              v-if="!!item && item.className !== 'no-item' && item.type !== 'accessories'"
              @click="handleTarget(item)"
              aria-label="TODO"
              class="d-inline-flex align-items-center justify-content-center btn btn-lg px-3 rounded"
              style="border: none; background: transparent;"
          >
            <i class="fa fa-map-marker" aria-hidden="true"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <b-pagination
        v-if="source.name === 'Datis'"
        :disabled="rows < perpage || isLoading"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perpage"
        hide-ellipsis
        @change="changeCurrentPage"
    >
    </b-pagination>
  </div>
</template>

<script>
import _filter from "lodash/filter";
import AlertModal from "@/components/alert/AlertModal";
import VocalModal from "@/components/dashboard/widgets/VocalContent";
import ToList from "@/components/dashboard/transformers/ToList";
import {EventBus} from "@/components/dashboard/eventbus/EventBus";
import Utils from "@/services/utils.js";
import {BPagination} from 'bootstrap-vue';
import UiRelativeDate from '@/components/ui/RelativeDate'
import UiButton from '@/components/ui/Button2'
import API from '@/services/API'
import axios from 'axios'
import LostcomConfirmContent from '@/components/dashboard/widgets/LostcomConfirmContent'
import {useDvFlag, useDvFlagAccess} from "../../../services/featureFlag";

export default {
  components: {
    BPagination,
    UiRelativeDate,
    UiButton,
    LostcomConfirmContent,
  },
  props: {
    source: {
      type: Object,
      required: true,
    },
    resize: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
    },

  },
  data() {
    return {
      headers: [],
      list: [],
      meta: [],
      filters: [],
      activeFilters: [["1", "2", "3", "4", "5"]],
      textFilter: "",
      textFilterDati: "",
      onlyAlert: false,
      currentPage: 1,
      perpage: 11,
      isLoading: true,
      lostComDisableButton: false
    };
  },
  mounted: function () {
    if (!useDvFlagAccess('beepiz-dashboard-live-session-can:read')) {
      this.$router.push({ name: 'AccessDenied', params: { slug: "dashboard"} })
    }
    EventBus.$on("source-ready", (event) => {
      if (event.source == this.source.name) {
        let sourceName = this.source.name
        if (sourceName != null) {
          let {headers, data, filters} = ToList[sourceName](event.data)
          this.headers = headers
          this.list = data
          this.filters = filters
          this.meta = event.meta
          this.isLoading = false
        }
      }
    })
  },
  computed: {
    hasLocationVisibility() {
      const roles = [
        "beepiz-superadministrator",
        "beepiz-administrator",
        "beepiz-manager",
        "beepiz-maintenance",
        "beepiz-supervisor",
      ]
      return window.V.acl.roles.some((r) => roles.indexOf(r) >= 0)
    },
    rows() {
      return this.meta.total
    },
    filteredList() {
      // Filter only if ther is an active filter
      if (this.textFilter !== "" || this.onlyAlert === true) {
        // Sanitize the filter and strip accents
        const sanitizedFilter = Utils.strip(
            Utils.sanitize(this.textFilter.toLowerCase())
        )

        return _filter(this.list, (item) => {
          // If object is a dati
          if (item.type === "dati") {
            // Filter on dati by searching sanitizedFilter in sanitized name
            if (
                Utils.strip(Utils.sanitize(item.cellsMarkup[0].toLowerCase())).includes(
                    sanitizedFilter
                )
            ) {
              return true
            }
            return false
          }
          // Or if it's an event
          else if (item.type === "event") {
            // If onlyAlert, we must combine eventCategory filter and text filter
            if (this.onlyAlert === true) {
              // Filter only events having an alertId and eventCategory to 1 (criticity of alerts)
              if (item.alertId && item.eventCategory === "1") {
                if (this.textFilter !== "") {
                  // Filter on event by searching sanitizedFilter in sanitized event label or sanitized dati name
                  if (
                      Utils.strip(
                          Utils.sanitize(item.cellsMarkup[0].toLowerCase())
                      ).includes(sanitizedFilter) ||
                      Utils.strip(
                          Utils.sanitize(item.cellsMarkup[1].toLowerCase())
                      ).includes(sanitizedFilter)
                  ) {
                    return true
                  }
                } else {
                  return true
                }
              }
            } else {
              if (this.textFilter !== "") {
                // Filter on event by searching sanitizedFilter in sanitized event label or sanitized dati name
                if (
                    Utils.strip(
                        Utils.sanitize(item.cellsMarkup[0].toLowerCase())
                    ).includes(sanitizedFilter) ||
                    Utils.strip(
                        Utils.sanitize(item.cellsMarkup[1].toLowerCase())
                    ).includes(sanitizedFilter)
                ) {
                  return true;
                }
              } else {
                return true;
              }
            }
            return false;
          }
          // For the unhandled cases
          else {
            return false;
          }
        });
      } else {
        return this.list;
      }
    },
    filterPlaceholder() {
      if (this.headers[0]) {
        return this.$t("home.widgets.searcha") + " " + this.headers[0];
      }
      return this.$t("home.widgets.search")
    },
  },
  destroyed: function () {
    EventBus.$off();
  },
  methods: {
    useDvFlagAccess,
    isLostcomAged(item) {
      const now = new Date()
      const lostComAt = new Date(item.rowData.lost_com_at.date)
      const diff = now - lostComAt
      const diffInHours = Math.floor(diff / 1000 / 60 / 60)
      return diffInHours > 24
    },
    handleRemoveLostcom(item) {
      const endingSessionsData = {
        lost_com_sessions: [
          {
            "dati_id": item.rowData.dati.id,
            "datiSession_id": item.rowData.datiSession_id,
          },
        ]
      }
      window.Vfc.$refs.confirm.show({
        title: Utils.t('home.widgets.list.lostcom_confirm_title'),
        content: null,
        content_component: LostcomConfirmContent,
        content_component_props: {
          profile_id: item.rowData.dati.profile_id,
        },
        callbackYes: () => {
          this.lostComDisableButton = true
          axios.post(API.endpoints.datis.endLostComSessions, endingSessionsData)
              .then(() => {
                EventBus.$emit('source-ready', 'Events');
                window.Vfc.$refs.messages.sendMessage(
                    "success",
                    Utils.t("home.widgets.list.lostcom_confirm_message")
                );
              })
              .catch((error) => {
                window.Vfc.$refs.messages.sendMessage("error", error)
              })
              .finally(() => {
                this.lostComDisableButton = false
              });
        },
        yesButtonText: Utils.tc("global.confirm"),
        noButtonText: Utils.tc("global.cancel"),
      });
    },
    notInRowType(rowType) {
      return ["lostCom", "vocal"].includes(rowType)
    },
    playVocal(item) {
      const attachment = item.rowData.attachment.pop()

      axios.get(API.endpoints.attachment.vocal + "/" + attachment.attachment_file_id, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "OPTIONS",
        }
      })
          .then(function (response) {
            window.Vfc.modalProps = {
              title: Utils.t("modal.audioPlayer.title"),
              width: "700px",
              height: "260px",
              resetContent: true
            };
            window.Vfc.modalComponentProps = {
              urlVocal: response.data,
              attachmentData: attachment,
              eventData: item.rowData
            };
            window.Vfc.modalComponent = VocalModal;
            window.Vfc.blurMode(true);
            window.Vfc.$refs.modal.show(() => {
            });
          })
          .catch((error) => {
            window.Vfc.$refs.messages.sendMessage("error", error)
          });


    },
    handleTarget: function (item) {
      EventBus.$emit("list-dati-click", item);
    },
    handleClick: function (item) {
      if (item.type == "event") {
        if (item.alertUrl && Utils.can("beepiz-select-alerts")) {
          window.Vfc.modalProps = {
            title: Utils.t("alerts.title"),
            width: "1000px",
            height: "100%",
            type: "danger",
          };
          window.Vfc.modalComponentProps = {
            url: item.alertUrl,
            id: item.alertId,
            ack: item.alertAcked
          };
          window.Vfc.modalComponent = AlertModal;
          window.Vfc.blurMode(true);
          window.Vfc.$refs.modal.show(() => {
          });
        }
      }
    },
    handleCheck: function () {
      this.onlyAlert = !this.onlyAlert;
    },
    changeCurrentPage(currentPage) {
      this.source.page = currentPage;
      this.isLoading = true;
      this.source.loadData();
    },
    SearchDatiByName() {
      if (this.textFilterDati == "") {
        this.source.query = null;
      } else {
        this.source.query = this.textFilterDati;
      }
      this.isLoading = true;
      this.source.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.capitalize {
  text-transform: capitalize;
}

.list-table-wrapper {
  height: calc(100% - 60px);
  overflow-y: scroll;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
}

ul.pagination.b-pagination {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.queryDati-wrapper {
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 10px;
  cursor: pointer;
  font-size: 1.2rem;
}
</style>
